export default "__VITE_ASSET__BCASgHD1__"